<template>
  <div
    class="d-flex justify-content-between heading"
  >
    <h3 class="d-flex">
      <i class="i-logo m-r-10 align-self-center" />
      <span class="font-weight-bold">
        {{ title }}
      </span>
    </h3>
    <span class="date font-weight-bold">
      {{ date }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'VacancyHeading',
  props: {
    title: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
};
</script>
